export default __webpack_public_path__ + "media/color/dbc-92feed89.svg";